module.exports = __webpack_public_path__ + "img/shops.ea0dbb11.png";